import { useEffect } from "react";
import styles from "./Carousel.module.scss";

interface CarouselProps {
  className: string;
  slides: Array<{
    img: { src: string; width: string; height: string };
    quote: string;
    name: string;
    role: string;
  }>;
}

const Carousel = ({ className, slides }: CarouselProps) => {
  const lastIndex = slides.length - 1;
  const onPrevious = () => {
      const prevTwoEl = document.getElementsByClassName(styles["prev-2"])[0],
        newPrevTwoEl =
          (prevTwoEl?.previousSibling as HTMLElement) ||
          document.getElementsByClassName(styles.slide)[4],
        prevEl = document.getElementsByClassName(styles.prev)[0],
        activeEl = document.getElementsByClassName(styles.active)[0],
        nextEl = document.getElementsByClassName(styles.next)[0],
        nextTwoEl = document.getElementsByClassName(styles["next-2"])[0];

      newPrevTwoEl?.classList.toggle(styles["prev-2"]);
      prevTwoEl?.classList.toggle(styles["prev-2"]);
      prevTwoEl?.classList.toggle(styles.prev);
      prevEl?.classList.toggle(styles.prev);
      prevEl?.classList.toggle(styles.active);
      activeEl?.classList.toggle(styles.active);
      activeEl?.classList.toggle(styles.next);
      nextEl?.classList.toggle(styles.next);
      nextEl?.classList.toggle(styles["next-2"]);
      nextTwoEl?.classList.toggle(styles["next-2"]);
    },
    onNext = () => {
      const prevTwoEl = document.getElementsByClassName(styles["prev-2"])[0],
        prevEl = document.getElementsByClassName(styles.prev)[0],
        activeEl = document.getElementsByClassName(styles.active)[0],
        nextEl = document.getElementsByClassName(styles.next)[0],
        nextTwoEl = document.getElementsByClassName(styles["next-2"])[0],
        newNextTwoEl =
          (nextTwoEl?.nextSibling as HTMLElement) ||
          document.getElementsByClassName(styles.slide)[0];

      prevTwoEl?.classList.toggle(styles["prev-2"]);
      prevEl?.classList.toggle(styles.prev);
      prevEl?.classList.toggle(styles["prev-2"]);
      activeEl?.classList.toggle(styles.active);
      activeEl?.classList.toggle(styles.prev);
      nextEl?.classList.toggle(styles.active);
      nextEl?.classList.toggle(styles.next);
      nextTwoEl?.classList.toggle(styles.next);
      nextTwoEl?.classList.toggle(styles["next-2"]);
      newNextTwoEl?.classList.toggle(styles["next-2"]);
    };

  const applyClasses = () => {
    const slideEl = document.getElementsByClassName(styles.slide);
    !slideEl[0]?.classList.contains(styles.active) &&
      slideEl[0]?.classList.add(styles.active);
    !slideEl[1]?.classList.contains(styles.next) &&
      slideEl[1]?.classList.add(styles.next);
    !slideEl[2]?.classList.contains(styles["next-2"]) &&
      slideEl[2]?.classList.add(styles["next-2"]);
    !slideEl[lastIndex - 1]?.classList.contains(styles["prev-2"]) &&
      slideEl[lastIndex - 1]?.classList.add(styles["prev-2"]);
    !slideEl[lastIndex]?.classList.contains(styles.prev) &&
      slideEl[lastIndex]?.classList.add(styles.prev);
  };
  useEffect(() => {
    // Check if the page has already loaded
    if (document.readyState === "complete") {
      applyClasses();
    } else {
      window.addEventListener("load", applyClasses);
      return () => window.removeEventListener("load", applyClasses);
    }
  }, []);

  return (
    <div className={`${styles.section} ${className}`}>
      <div className={styles.carousel}>
        <div className={styles["carousel-slides"]}>
          {slides.map((slide, i) => (
            <div key={i} className={styles.slide}>
              <div className={styles.wrapper}>
                <img
                  {...slide.img}
                  alt={slide.name + "'s Quote"}
                  // loading="lazy"
                />
              </div>
              <div className={styles.content}>
                <h4 className="bold">{slide.quote}</h4>
                <p>{slide.name}</p>
                <p>{slide.role}</p>
              </div>
            </div>
          ))}
        </div>
        <button
          className={styles["button-left"]}
          onClick={onPrevious}
          title="Previous Slide"
          aria-label="previous slide"
        />
        <button
          className={styles["button-right"]}
          onClick={onNext}
          title="Next Slide"
          aria-label="next slide"
        />
      </div>
    </div>
  );
};

export default Carousel;
